module.exports = __webpack_public_path__ + "img/logo_small.b3ff97ff.svg";